import React from "react";
import { Category } from "../../../../src/CommonFunctions";
import {
  logoOverlayFetcher,
  textOverlayFetcher,
  getDynamicFontSize,
  isBottleCategory,
} from "../../../pages/ImprovedShopPage/SingleProductPageHelpers";

interface ProductImageProps {
  imageUrl: string;
  customImageUrl?: string;
  category: (typeof Category)[keyof typeof Category];
  isMobile: boolean;
  fontStyle?: string;
  customText?: string;
}

export const ProductImage: React.FC<ProductImageProps> = ({
  imageUrl,
  customImageUrl,
  category,
  isMobile,
  fontStyle,
  customText,
}) => {
  return (
    <div className="single-product-page-image-wrapper">
      <img className="single-product-page-image" src={imageUrl} alt="Product" />
      {category !== Category.Default && customImageUrl && (
        <img
          className="single-product-page-custom-overlay-image"
          src={customImageUrl}
          alt="Custom Product"
          style={{
            position: "absolute",
            transform: "translate(-50%, -50%)",
            ...logoOverlayFetcher(category, isMobile),
          }}
        />
      )}
      {isBottleCategory(category) && customText && (
        <p
          className="bottle-font-preview"
          style={{
            fontFamily: fontStyle,
            position: "absolute",
            color: "#9e9e9e",
            transform: "translate(-50%, -50%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            ...textOverlayFetcher(category, isMobile),
            fontSize: getDynamicFontSize(
              textOverlayFetcher(category, isMobile)?.baseFontSize,
              customText
            ),
          }}
        >
          {customText}
        </p>
      )}
      {category !== Category.Default && <CustomizationDisclaimer />}
    </div>
  );
};

const CustomizationDisclaimer: React.FC = () => (
  <p className="single-product-page-custom-disclaimer">
    * Please note that the final product may vary slightly from the images shown
    depending on screen settings and design adjustments.
    <br />
    **Design colors may be adjusted depending on the garment color selected. (IE
    a black logo will be turned to white if a black garment is chosen.)
  </p>
);

export default ProductImage;
